export default "__VITE_ASSET__DMUhCZbA__"